<template>
  <div class="cover">
    <template v-if="isWechat">
      <div class="guide">
        <img class="img2" :src="require('@/assets/img/dq/guide.png')" />
      </div>
      <div class="line flex">
        点击右上角的
        <img :src="require('@/assets/img/dq/guide1.png')" />
        按钮
      </div>
      <div class="line flex">
        选择
        <img :src="require('@/assets/img/dq/guide2.png')" />
      </div>
    </template>
    <template v-else>
      <span style="font-size: 16px">跳转链接中...</span>
    </template>
  </div>
</template>

<script>
const isWechat = () => {
  return (
    String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) ===
    'micromessenger'
  );
};


export default {
  computed: {
    isWechat() {
      return isWechat();
    },
  },
  mounted() {
    let path = this.$route.query.path;

    if (!isWechat()) {
      window.location.href = path;
    }
  },
};
</script>

<style lang="less" scoped>
.cover {
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
}

.guide {
  text-align: right;
  img {
    margin-right: 10px;
    width: 20px;
    height: 20px;
  }
}

.line {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
}
</style>